import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteVesselProducts } from '../../../common/api/clients/vessel.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useDeleteVesselProducts = (vesselId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (productIds: string[]) => deleteVesselProducts(vesselId, productIds),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queries.vessels.detail(vesselId)._ctx.products.queryKey,
            });
        },
    });
};
